import { theme } from '@frontend/theme';

export const backgroundColor = `${theme.colors.neutral90}`;
